import { useEffect, useState } from "react";

const STORAGE_KEY = "yn.variant";
const VALID = new Set(["A", "B"]);
const SPLIT_B = 0.1; // 10 % see B, 90 % see A

function readOverride() {
  if (typeof window === "undefined") return null;
  try {
    const p = new URLSearchParams(window.location.search).get("variant");
    if (p && VALID.has(p.toUpperCase())) return p.toUpperCase();
  } catch (_e) {
    /* silent */
  }
  return null;
}

function assign() {
  return Math.random() < SPLIT_B ? "B" : "A";
}

/**
 * Deterministic 90/10 hero variant assignment (A = control, B = email-first).
 * Sticky per browser session via sessionStorage. ?variant=A|B in the URL
 * forces + persists that variant for QA.
 */
export function useHeroVariant() {
  const [variant, setVariant] = useState("A");
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const override = readOverride();
      if (override) {
        sessionStorage.setItem(STORAGE_KEY, override);
        setVariant(override);
        return;
      }
      const existing = sessionStorage.getItem(STORAGE_KEY);
      if (existing && VALID.has(existing)) {
        setVariant(existing);
        return;
      }
      const chosen = assign();
      sessionStorage.setItem(STORAGE_KEY, chosen);
      setVariant(chosen);
    } catch (_e) {
      /* sessionStorage unavailable, default to A */
    }
  }, []);
  return variant;
}

export function getVariant() {
  if (typeof window === "undefined") return "A";
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "A";
  } catch (_e) {
    return "A";
  }
}
